import config from 'app-config'
import request from 'local_modules/request'
import { reducers } from 'redux/core'
import { constants } from 'helpers'


const set = (accessLevel) => {
  reducers.marketplace.accessLevel.set(accessLevel)
}

const setFetched = (isFetched) => {
  reducers.marketplace.accessLevel.setFetched(isFetched)
}

// Access level
const fetchSportAccessLevel = () => (
  request.get(constants.marketplace.whoami)
    .then(({ data }) => data)
    .then((sportAccessLevel) => {
      reducers.marketplace.accessLevel.setSport(sportAccessLevel)
    })
)

const fetchEduAccessLevel = () => (
  request.get(constants.edu.whoami)
    .then(({ data }) => data)
    .then((eduAccessLevel) => {
      reducers.marketplace.accessLevel.setEdu(eduAccessLevel)
    })
)

const fetchRpcAccessLevel = () => (
  request.get(constants.rpc.whoami)
    .then(({ data }) => data)
    .then((rpcAccessLevel) => {
      reducers.marketplace.accessLevel.setRpc(rpcAccessLevel)
    })
)

// Cashier access level
const fetchEduCashierSettings = () => {
  return request.get(constants.edu.cashierSettings)
    .then(({ data }) => {
      if (data.error) {
        console.log('catch', constants.edu.cashierSettings + `?all=true`)
        console.log(data.error)
        return []
      }

      return data
    })
}

const fetchRpcCashierSettings = () => {
  return request.get(constants.rpc.cashierSettings)
    .then(({ data }) => {
      if (data.error) {
        console.log('catch', constants.rpc.cashierSettings + `?all=true`)
        console.log(data.error)
        return []
      }

      return data
    })
}

const fetchEduSchools = () => {
  return request.get(constants.edu.schools + `?all=true`)
    .then(({ data }) => {
      if (data.error) {
        console.log('catch', constants.edu.schools + `?all=true`)
        console.log(data.error)
        return []
      }

      return data
    })
}

const fetchRpcSchools = () => {
  return request.get(constants.rpc.schools + `?all=true`)
    .then(({ data }) => {
      if (data.error) {
        console.log('catch', constants.rpc.schools + `?all=true`)
        console.log(data.error)
        return []
      }

      return data
    })
}

const fetchEduCashierAccessLevel = () => (
  Promise.all([
    fetchEduCashierSettings(),
    fetchEduSchools(),
  ])
    .then(
      ([ access, schools ]) => {
        return access.map((data) => ({
          ...data,
          school: {
            ...data.school,
            ...(schools.find(({ id }) => id === data.school.id) || {})
          }
        }))
      },
      (error) => {
        console.log('catch getEduCashierAccessLevel', constants.edu.cashierSettings)
        console.log('catch getEduCashierAccessLevel', constants.edu.schools + `?all=true`)
        console.log(error)
        return []
      })
    .then((eduCashierAccessLevel) => {
      reducers.marketplace.accessLevel.setEduCashierAccessLevel(eduCashierAccessLevel)
    })
)

const fetchRpcCashierAccessLevel = () => (
  Promise.all([
    fetchRpcCashierSettings(),
    fetchRpcSchools(),
  ])
    .then(
      ([ access, schools ]) => {
        console.log({ access, schools })
        return Boolean(typeof access === 'object' && typeof schools ==='object') ? access.map((data) => ({
          ...data,
          school: {
            ...data.school,
            ...(schools.find(({ id }) => id === data.school.id) || {})
          }
        })) : []
      },
      (error) => {
        console.log('catch getRpcCashierAccessLevel', constants.rpc.cashierSettings)
        console.log('catch getRpcCashierAccessLevel', constants.rpc.schools + `?all=true`)
        console.log(error)
        return []
      })
    .then((rpcCashierAccessLevel) => {
      reducers.marketplace.accessLevel.setRpcCashierAccessLevel(rpcCashierAccessLevel)
    })
)

// Test mock
const setTestMockData = (search) => {
  if (config.api === 'test') {
    // const isAdmin     = config.api === 'test' ? typeof query.admin !== 'undefined' : accessLevel.status === 'admin'
    // const isCashier   = config.api === 'test' ? typeof query.cashier !== 'undefined' : accessLevel.status === 'cashier'
    const isCustomer = config.api === 'test' && search.includes('customer')
    const isCashier  = config.api === 'test' && search.includes('cashier')

    // if (isAdmin) {
    //   updateInitialState([ 'me', 'isAdmin' ], true)
    //   // TODO filter accessLevel.tools
    // }

    if (isCashier) {
      reducers.marketplace.accessLevel.setEdu({ status: 'cashier' })
      reducers.marketplace.accessLevel.setSport({ status: 'cashier' })
    }
    if (isCustomer) {
      reducers.marketplace.accessLevel.setEdu({ status: 'customer' })
      reducers.marketplace.accessLevel.setSport({ status: 'customer' })
    }

    if (search.includes('id')) {
      const id = search.replace(/.*id=/, '').replace(/&.*/, '')

      reducers.me.update({ id: Number(id) })
    }
  }

  return Promise.resolve()
}

const fetch = () => {
  const search = window.location.search

  return Promise.all([
    fetchSportAccessLevel(),
    fetchEduAccessLevel(),
    fetchEduCashierAccessLevel(),
    fetchRpcAccessLevel().catch((error) => console.log('fetchRpcAccessLevel error', error)),
    fetchRpcCashierAccessLevel().catch((error) => console.log('fetchRpcCashierAccessLevel error', error)),
  ])
    .then(() => setTestMockData(search))
    .then(() => {
      reducers.marketplace.accessLevel.setFetched(true)
    })
}


export default {
  set,
  setFetched,
  fetch,
}
